module.exports = __webpack_public_path__ + "img/rod_07.ebe99095.svg";